import type {RelayEndpoint} from "@client/contracts";
import {type FC, useState} from "react";
import {rpc} from "../../store/rpcs.mjs";

type Props = {
    endpoint: RelayEndpoint;
    onIssued: (apiUrl: string) => void;
    onChanged: () => Promise<void>;
};

export const RelayRow: FC<Props> = (props) => {
    const {endpoint, onIssued, onChanged} = props;
    const [pending, setPending] = useState(false);
    const isActive = endpoint.state === "active";

    const rotate = async () => {
        if (!confirm("Выпустить новый ключ? Текущий перестанет работать сразу.")) {
            return;
        }

        setPending(true);

        try {
            const {relay} = await rpc.query({relay: {rotate: [{id: endpoint.id}]}});
            onIssued(relay.rotate.apiUrl);
        } finally {
            setPending(false);
        }
    };

    const toggle = async () => {
        setPending(true);

        try {
            await rpc.query({relay: {setState: [{id: endpoint.id, active: !isActive}]}});
            await onChanged();
        } finally {
            setPending(false);
        }
    };

    const remove = async () => {
        if (!confirm(`Удалить «${endpoint.title}»? Ключ перестанет работать.`)) {
            return;
        }

        setPending(true);

        try {
            await rpc.query({relay: {remove: [{id: endpoint.id}]}});
            await onChanged();
        } finally {
            setPending(false);
        }
    };

    return (
        <tr>
            <td>{endpoint.title}</td>
            <td>
                <code>{endpoint.region}</code>
            </td>
            <td>{isActive ? "активен" : "приостановлен"}</td>
            <td className="actions">
                <button className="outline" disabled={pending} onClick={toggle}>
                    {isActive ? "Приостановить" : "Включить"}
                </button>
                <button className="outline" disabled={pending} onClick={rotate}>
                    {"Новый ключ"}
                </button>
                <button className="outline secondary" disabled={pending} onClick={remove}>
                    {"Удалить"}
                </button>
            </td>
        </tr>
    );
};
